export enum SearchableTableColumnType {
    string,
    percentage,
    number,
    date,
    dropdown,
    button,
    template,
}
